import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  radii,
  spacing,
} from "@softmax/design-system/tokens.stylex";

export const composerStyles = stylex.create({
  form: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space12,
    marginBlock: spacing.space16,
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space6,
    fontSize: fontSizes.small,
  },
  textarea: {
    width: "100%",
    boxSizing: "border-box",
    resize: "vertical",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.borderStrong,
    borderRadius: radii.small,
    backgroundColor: colors.surfaceAlt,
    color: colors.foreground,
    fontFamily: fonts.sans,
    fontSize: fontSizes.body,
    lineHeight: 1.5,
    padding: spacing.space12,
    outline: {
      default: "none",
      ":focus-visible": `2px solid ${colors.foreground}`,
    },
    outlineOffset: 3,
  },
  actions: { display: "flex", flexWrap: "wrap", gap: spacing.space8 },
});
